/* SAKERAMA — home + shared logic */
(function(){
  'use strict';

  /* mobile nav */
  var burger = document.getElementById('burger');
  var menu = document.getElementById('menu');
  if (burger && menu){
    burger.addEventListener('click', function(){
      burger.classList.toggle('open'); menu.classList.toggle('open');
    });
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ burger.classList.remove('open'); menu.classList.remove('open'); });
    });
  }

  /* countdown to 25 July 2026, 12:00 SGT (UTC+8) */
  var TARGET = Date.UTC(2026, 6, 25, 4, 0, 0);
  var els = {
    d: document.getElementById('cd-d'), h: document.getElementById('cd-h'),
    m: document.getElementById('cd-m'), s: document.getElementById('cd-s')
  };
  function pad(n){ return (n<10?'0':'')+n; }
  function tick(){
    if (!els.d) return;
    var diff = Math.max(0, TARGET - Date.now());
    var sec = Math.floor(diff/1000);
    var d = Math.floor(sec/86400); sec -= d*86400;
    var h = Math.floor(sec/3600);  sec -= h*3600;
    var m = Math.floor(sec/60);    sec -= m*60;
    els.d.textContent = pad(d); els.h.textContent = pad(h);
    els.m.textContent = pad(m); els.s.textContent = pad(sec);
  }
  tick(); setInterval(tick, 1000);

  /* THE SCENE — horizontal film-strip: seamless idle drift + drag */
  var rail = document.getElementById('sceneRail');
  if (rail){
    var originals = Array.prototype.slice.call(rail.children);
    originals.forEach(function(node){
      var c = node.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      rail.appendChild(c);
    });
    var paused = false, SPEED = 0.45, resumeTO;
    function half(){ return rail.scrollWidth / 2; }
    function loop(){
      if (!paused){
        rail.scrollLeft += SPEED;
        if (rail.scrollLeft >= half()) rail.scrollLeft -= half();
      }
      requestAnimationFrame(loop);
    }
    function pause(){ paused = true; clearTimeout(resumeTO); }
    function resumeSoon(){ clearTimeout(resumeTO); resumeTO = setTimeout(function(){ paused = false; }, 1400); }
    rail.addEventListener('mouseenter', pause);
    rail.addEventListener('mouseleave', function(){ paused = false; });
    rail.addEventListener('wheel', function(e){
      pause(); resumeSoon();
      /* on non-touch (mouse wheel): redirect vertical scroll to horizontal */
      if (!e.ctrlKey && Math.abs(e.deltaY) > Math.abs(e.deltaX)){
        e.preventDefault();
        rail.scrollLeft += e.deltaY * 1.2;
        if (rail.scrollLeft >= half()) rail.scrollLeft -= half();
        if (rail.scrollLeft < 0) rail.scrollLeft += half();
      }
    }, { passive: false });
    rail.addEventListener('touchstart', pause, { passive: true });
    rail.addEventListener('touchend', resumeSoon, { passive: true });

    var down = false, startX = 0, startLeft = 0, moved = false;
    rail.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
      pause(); rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      rail.scrollLeft = startLeft - dx;
      if (rail.scrollLeft >= half()) rail.scrollLeft -= half();
      if (rail.scrollLeft < 0) rail.scrollLeft += half();
    });
    function endDrag(){ if (!down) return; down = false; resumeSoon(); }
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); } }, true);

    requestAnimationFrame(loop);

    /* tap-to-reveal colour on touch devices */
    rail.addEventListener('click', function(e){
      if (moved) return;
      var photo = e.target.closest('.gphoto');
      if (!photo) return;
      var active = rail.querySelector('.gphoto.tapped');
      if (active && active !== photo) active.classList.remove('tapped');
      photo.classList.toggle('tapped');
    });
  }

  /* YOSAKOI — wheel-to-horizontal scroll on desktop */
  var yokoRail = document.getElementById('yokoRail');
  if (yokoRail){
    yokoRail.addEventListener('wheel', function(e){
      if (!e.ctrlKey && Math.abs(e.deltaY) > Math.abs(e.deltaX)){
        e.preventDefault();
        yokoRail.scrollLeft += e.deltaY * 1.2;
      }
    }, { passive: false });
  }

})();
